import { Link } from "@inertiajs/react";
import { Button, buttonVariants } from "./ui/button";

type Props = {
  prev: {
    href: string | null;
    data: any;
  };
  next: {
    href: string | null;
    data: any;
  };
};

export default function PaginationButtons({ prev, next }: Props) {
  return (
    <div className="flex gap-2">
      {prev.href ? (
        <Link
          href={prev.href}
          data={prev.data}
          className={buttonVariants({ variant: "outline", size: "sm" })}
        >
          Previous
        </Link>
      ) : (
        <Button variant="outline" disabled size="sm">
          Previous
        </Button>
      )}
      {next.href ? (
        <Link
          href={next.href}
          data={next.data}
          className={buttonVariants({ variant: "outline", size: "sm" })}
        >
          Next
        </Link>
      ) : (
        <Button variant="outline" disabled size="sm">
          Next
        </Button>
      )}
    </div>
  );
}
